import script from "./ButtonRoundedSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonRoundedSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonRoundedSecondary.vue?vue&type=style&index=0&id=f1bd778a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1bd778a"]])

export default __exports__